import React from 'react';
import { SectionContainerLight } from '../common/sections/SectionContainerLight';
import { procedure_steps } from '@/constants';
import ProcedureSteps from '../common/procedure-steps/ProcedureSteps';

export const SectionWorkshopProcedure = () => {
    return (
        <SectionContainerLight id='workshop-procedure' additionalClassName='py-6 my-8 md:my-4'>
        <ProcedureSteps
        title="Prosedur Pendaftaran"
        subtitle=""
        steps={procedure_steps}
        />
        </SectionContainerLight>
    );
};